import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/kasturifoodproducts-app/src/app/about-us/AboutUsClient.tsx");
